<template>
  <div class="rounded mt-3">
    <!--  -->
    <div class="d-flex mt-3" style="align-items:center;">
      <div style="flex-grow:1;" class="pl-2">
        <p class="" style="">
          Click on any column header to sort on that column. Click again to
          reverse order.
        </p>
      </div>
      <div class="form-group form-inline pr-2">
        <span class="mr-1">Show </span
        ><select v-model="PageSize" class="form-control"
          ><option :value="10">10</option
          ><option :value="15">15</option
          ><option :value="20">20</option
          ><option :value="25">25</option
          ><option :value="50">50</option
          ><option :value="100">100</option
          ><option :value="200">200</option
          ><option :value="500">500</option
          ><option :value="1000">1000</option></select
        ><span class="ml-1"> entries</span>
      </div>
    </div>
    <!--  -->
    <table class="table table-hover table-striped mb-2">
      <thead>
        <tr>
          <th
            style="cursor: pointer; width: 10%;"
            @click="setSortFieldAndOrder('KEYID')"
          >
            Id
          </th>
          <th
            style="cursor: pointer; width: 80%;"
            @click="setSortFieldAndOrder('KEYWORD')"
          >
            Keyword
          </th>
          <th style="width: 10%;" class="text-center">Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="exludedKeyword in getExcludedKeywordsData.Result"
          :key="exludedKeyword.keyid"
        >
          <td>{{ exludedKeyword.keyid }}</td>
          <td>{{ exludedKeyword.keyword }}</td>
          <td class="text-center">
            <b-form-checkbox
              style="cursor: pointer;"
              v-model="SelectedKeywords"
              :value="+exludedKeyword.keyid"
              switch
            />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- page Number -->
    <div class="d-flex mb-2" style="align-items: center;">
      <div style="flex-grow: 1;" class="pl-2">
        <p>
          Showing {{ (PageNumber - 1) * PageSize + 1 }} to
          {{ UpperLimit }}
          of {{ TotalRecords }} entries
        </p>
      </div>
      <div class="pr-2">
        <Pagination
          :data="getExcludedKeywordsData.Result"
          :totalPages="Math.ceil(TotalRecords / PageSize)"
          :total="TotalRecords"
          :perPage="PageSize"
          :currentPage="PageNumber"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <!-- page Number -->
  </div>
</template>

<script>
import Pagination from "../../../../components/Pagination.vue";
export default {
  name: "excludedKeywordsTable",
  data() {
    return {
      // SelectedKeywords: [],
      SortField: "",
      SortOrder: "",
      PageNumber: 1,
      PageSize: 10,
    };
  },
  components: {
    Pagination,
  },
  computed: {
    getExcludedKeywordsData() {
      return this.$store.getters["excludedKeywords/getExcludedKeywordsData"];
    },
    UpperLimit() {
      return this.TotalRecords < this.PageNumber * this.PageSize
        ? this.TotalRecords
        : this.PageNumber * this.PageSize;
    },
    TotalRecords() {
      return this.getExcludedKeywordsData.totalRecords;
    },
    SelectedKeywords: {
      get() {
        return this.$store.state.excludedKeywords.selectedKeywords;
      },
      set(val) {
        this.$store.commit("excludedKeywords/SET_SELECTED_KEYWORDS", val);
      },
    },
  },
  watch: {
    // SelectedKeywords(newVal) {
    //   this.$store.commit("excludedKeywords/SET_SELECTED_KEYWORDS", newVal);
    // },
    PageSize() {
      this.PageNumber = 1;
      this.updateData();
    },
  },
  methods: {
    onPageChange(page) {
      console.log("page changed", page);
      this.PageNumber = page;
      try {
        this.updateData();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
    setSortFieldAndOrder(SortField) {
      if (this.SortField === SortField) {
        this.SortOrder = this.SortOrder === "ASC" ? "DESC" : "ASC";
      } else {
        this.SortField = SortField;
      }
      this.updateData();
    },
    updateData() {
      this.$store
        .dispatch("excludedKeywords/getExcludedKeywords", {
          searchTerm: "",
          pageNumber: this.PageNumber,
          pageSize: this.PageSize,
          sortField: this.SortField,
          sortOrder: this.SortOrder,
        })
        .then((data) => {
          this.SortField = data.sortField;
          this.SortOrder = data.sortOrder;
          this.PageNumber = data.pageNumber;
          this.PageSize = data.pageSize;
        });
    },
  },
  created() {
    this.updateData();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
